import firebase from 'firebase/app'
import firestore from 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyBx0Hm6sFFtj50czQ8YMVh-FpnxdKcbL8g",
  authDomain: "laopeh-says-57915.firebaseapp.com",
  databaseURL: "https://laopeh-says-57915.firebaseio.com",
  projectId: "laopeh-says-57915",
  storageBucket: "laopeh-says-57915.appspot.com",
  messagingSenderId: "650342906841",
  appId: "1:650342906841:web:e57812de78d4b52e0737c8",
  measurementId: "G-3WRDP25F3R"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp


// WEBPACK FOOTER //
// ./src/firebase/init.js